module.exports = __webpack_public_path__ + "static/media/dmtd1.d94978df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/dmtd1.jpg
// module id = 324
// module chunks = 0